export const hasLetters = (value: string) => /[a-zA-Z]/.test(value)
